'use client'

import { useEffect, useState } from 'react'
import ProductCard from '../../../entities/ProductCard'
import {
    AddToCart,
    AddToPreferences,
    QuickView,
} from '@/features/productSearch/ProductCardActions'
import {
    useGetCartItemsQuery,
    useProductsCatalogMutation,
} from '@/shared/api-rtk'

export function HitsProducts({ onMount }) {
    const [data, setData] = useState([])
    const [error, setError] = useState(null)

    const { data: productsInCart, refetch } = useGetCartItemsQuery()

    const [getProducts] = useProductsCatalogMutation()

    useEffect(() => {
        if (data.length) return

        getProducts()
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    const sortedData = Object.values(res.data).sort(
                        (a, b) =>
                            new Date(b.date_available) - new Date(a.date_available)
                    )
                    setData(sortedData)
                    refetch()
                }
            })
            .catch((err) => setError(err))
            .finally(() => {
                setTimeout(() => onMount(), 500)
            })
    }, [data.length, getProducts, refetch, onMount])

    return (
        <div className="LatestContainer">
            <h1>Хиты продаж</h1>
            <div className="items-container">
                {data.map((item) => (
                    <ProductCard key={item.product_id} {...item}>
                        <QuickView productId={item.product_id} item={item} />
                        <AddToPreferences productId={item.product_id} item={item} />
                        <AddToCart
                            productId={item.product_id}
                            item={item}
                            cartContains={productsInCart?.data?.includes(
                                item.product_id
                            )}
                        />
                    </ProductCard>
                ))}
                {error && <span>Ошибка сервера, перезагрузите страницу</span>}
            </div>
        </div>
    )
}
